// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadClipModal-modulewrapper3-w"};